import { useId, useState } from "react";
import styles from "./ActionEntryPanel.module.css";
import downArrowIcon from "../../assets/double-down.svg";
import classNames from "classnames";
import { ActionEntryItem } from "../../lib/api/models";
import { convertDateStringToMonthDayYearFormat } from "../../lib/formatting";
import tableStyles from "../common/tables/Table/Table.module.css";

const strings = {
  title: "ACTION ENTRY",

  resultActionEntryDate: "Action Dt",
  agentCode: "Agnt",
  resultActionEntryPosted: "Action",

  noData: "No entries.",
};

type Props = {
  data: ActionEntryItem[];
};

export default function ActionEntryPanel({ data }: Props) {
  const contentId = useId();

  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className={styles.container}>
      <button
        className={styles.button}
        aria-controls={contentId}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((v) => !v)}
      >
        <div className={styles.expandCollapseIconContainer}>
          <img
            className={styles.expandCollapseIcon}
            src={downArrowIcon}
            alt=""
          />
        </div>
        <span className={styles.title}>{strings.title}</span>
        <div className={styles.expandCollapseIconContainer}>
          <img
            className={styles.expandCollapseIcon}
            src={downArrowIcon}
            alt=""
          />
        </div>
      </button>
      <div
        id={contentId}
        className={classNames(styles.content, {
          [styles.expanded]: isExpanded,
        })}
      >
        <div className={styles.innerContent}>
          {data.length === 0 ? (
            strings.noData
          ) : (
            <table className={tableStyles.container}>
              <thead className={tableStyles.container}>
                <tr className={styles.tableRowContainer}>
                  <th className={styles.headerTitleText}>
                    {strings.resultActionEntryDate}
                  </th>
                  <th className={styles.headerTitleText}>
                    {strings.agentCode}
                  </th>
                  <th className={styles.headerTitleText}>
                    {strings.resultActionEntryPosted}
                  </th>
                </tr>
              </thead>
              <tbody className={tableStyles.container}>
                {data.map((item, index) => (
                  <tr
                    key={`${item.agentCode}-${item.resultActionEntryDate}-${item.resultActionEntryPosted}-${index}`}
                    className={classNames(
                      styles.tableRowContainer,
                      tableStyles.tableRowButton,
                    )}
                  >
                    <td className={styles.entry}>
                      {convertDateStringToMonthDayYearFormat(
                        item.resultActionEntryDate,
                      )}
                    </td>
                    <td className={styles.entry}>{item.agentCode}</td>
                    <td className={styles.entry}>
                      {item.resultActionEntryPosted}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
